// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"135":"group-auth","638":"group-admin"}[chunkId] + "." + {"135":"675a1d6c","638":"a32fc9b2"}[chunkId] + ".js";
};